/**
 * Constantes dos estágios oficiais — espelham public.deal_stages.nome.
 *
 * IMPORTANTE: ofertas.status tem FK para deal_stages.nome (com ON UPDATE
 * CASCADE). Qualquer string fora deste vocabulário é REJEITADA pelo banco.
 * Sempre usar essas constantes em vez de literal — typo aqui = crash em runtime.
 */
export const DEAL_STAGES = {
  COLD: '0.0.Cold',
  IDENTIFICAR: '1.0.Identificar_Responsável',
  PROSPECTAR: '2.0.Prospectar',
  CONTACTADO: '2.1.Contactado_(Cold_Email)',
  CONTACTADO_R: '2.2.(R) Contactado_(Cold_Email)',
  ENVIAR_OFERTA: '3.0.Enviar_Nova_Oferta',
  OFERTA_ENVIADA: '3.1.Oferta_Enviada',
  OFERTA_ENVIADA_R: '3.2.(R) Oferta_Enviada',
  EM_ANALISE: '3.3.Em_Análise',
  EM_PROPOSTA: '3.4.Em_Proposta',
  EM_FECHAMENTO: '3.5.Em_Fechamento',
  PROPOSTA_ACEITA: '4.0.Proposta_Aceita',
  DESCARTADA: '7.0.Oferta_Descartada',
  OUTRO_CORRETOR: '7.1.Recebida_Outro_Corretor',
  DO_NOT_PROSPECT: '9.0.Do_Not_Prospect',
};
